import React from 'react';
import PropTypes from 'prop-types';

import HeadersFullPlus from './types/full-plus/HeadersFullPlus';
import HeadersFull from './types/full/HeadersFull';
import HeadersPartial from './types/partial/HeadersPartial';
import HeadersHistory from './types/history/HeadersHistory';
import HeadersShared from './types/shared/HeadersShared';
import HeadersCart from './types/cart/HeadersCart';

function HeadersFactory({ type, width, hasTitle, orderBy }) {
  const componentHeaders = {
    'Full#': HeadersFullPlus,
    'Full': HeadersFull,
    'Partial': HeadersPartial,
    'History': HeadersHistory,
    'Shared': HeadersShared,
    'Cart': HeadersCart,
  };

  return React.createElement(componentHeaders[type], { width, hasTitle, orderBy });
}

HeadersFactory.propTypes = {
  type: PropTypes.string.isRequired,
  width: PropTypes.any,
  hasTitle: PropTypes.bool,
  orderBy: PropTypes.array,
}

export default HeadersFactory;
